import React from 'react';

export default function ComparisonHero() {
  const scrollToCostSavings = () => {
    const element = document.getElementById('cost-savings');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-blue-900 to-teal-900 text-white py-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10">
        <h1 className="text-4xl md:text-6xl font-extrabold mb-6 tracking-tight">
          Save $123,000+ Over 1.5 Years
        </h1>
        <p className="text-xl md:text-2xl mb-4 text-teal-200 font-medium max-w-4xl mx-auto">
          Why Dinari Designs Outperforms In-House Employees for High-Rise Construction Detailing
        </p>
        <p className="text-lg md:text-xl mb-10 text-gray-300 max-w-3xl mx-auto">
          A comprehensive cost and value analysis comparing contracting Dinari Designs versus hiring an in-house detailer in Vancouver, BC.
        </p>
      </div>
    </section>
  );
}
